import React from 'react';
import styled from 'styled-components';

interface Props {
  type?: string;
  titleData: string[];
  picUrl: string;
}

const VisualImage: React.FC<Props> = ({ type, titleData, picUrl }) => {
  if (type === 'primary') {
    return (
      <Wrap>
        <Title>
          {titleData.map((title) => (
            <>
              {title}
              <br />
            </>
          ))}
        </Title>
        <Image src={picUrl} />
      </Wrap>
    );
  } else {
    return (
      <GrayWrap>
        <Title>
          {titleData.map((title) => (
            <>
              {title}
              <br />
            </>
          ))}
        </Title>
        <Image src={picUrl} />
      </GrayWrap>
    );
  }
};

export default VisualImage;

const Wrap = styled.div`
  position: relative; /*相対配置*/
`;

const GrayWrap = styled.div`
  position: relative; /*相対配置*/
  filter: grayscale(0.9);
`;

const Image = styled.img`
  width: 100%;
`;

const Title = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  color: white;
  font-weight: bold;
  width: 100%;
  text-align: center;

  /* 960px以上 PC */
  @media screen and (min-width: 960px) {
    font-size: 10em;
  }
  /* 768-959px iPad */
  @media screen and (min-width: 768px) and (max-width: 959px) {
    font-size: 6em;
  }

  /* 540-767px スマホ */
  @media screen and (max-width: 767px) {
    font-size: 8em;
  }

  /* 539px以下 スマホ*/
  @media screen and (max-width: 539px) {
    font-size: 3em;
  }
`;
